<template>
  <div
    class="flex-fill mb-3 position-relative ml-3"
    style="max-height: 625px; overflow: hidden"
  >
    <div
      style="width: 2rem; height: 2rem"
      class="d-flex align-self-center position-absolute custom-absolute-positioning spinner-border text-primary"
      role="status"
      v-if="loadingPreview"
    ></div>
    <div
      class="d-flex align-self-center position-absolute custom-absolute-positioning"
      style="min-height: 100%"
      v-if="selectedTemplateBody && loadingPreview == false"
    >
      <div class="whatsapp-container">
        <div class="whatsapp-body">
          <div class="whatsapp-message-body">
            {{ selectedTemplateBody }}
          </div>
        </div>
        <div class="whatsapp-buttons-group">
          <div
            class="whatsapp-button"
            v-for="(button, index) in selectedTemplateButtons"
            :key="index"
          >
            {{ button }}
          </div>
        </div>
      </div>
    </div>
    <img
      class="img-fluid"
      src="../assets/wallpaper-whatsapp.jpg"
      style="min-width: 100%; min-height: 100%; object-fit: cover"
    />
  </div>
</template>

<script>
export default {
  props: ["selectedTemplateBody", "selectedTemplateButtons", "loadingPreview"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.whatsapp-container {
  padding: 1em;
  margin: 1em;
  height: 100%;
  width: 100%;
}
.whatsapp-body {
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 1em;
  border-radius: 10px;
  color: #606060;
  background-color: #fff;
}
.whatsapp-body .whatsapp-message-body {
  white-space: pre-wrap;
}
.whatsapp-buttons-group {
  display: flex;
  flex-wrap: wrap;
  padding: 1.4em 0;
  gap: 0.8em;
}
.whatsapp-buttons-group .whatsapp-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 40%;
  background-color: #fff;
  padding: 1em;
  border-radius: 10px;
  font-size: 14px;
  color: #46baea;
}
.custom-absolute-positioning {
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.d-flex.groupbuttons {
  gap: 3em;
}
</style>